/******/ (function() { // webpackBootstrap
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** Utility class for debouncing function calls **/
var Debouncer = /*#__PURE__*/function () {
  function Debouncer() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
    _classCallCheck(this, Debouncer);
    this.delay = delay;
    this.timeoutId = null;
  }
  return _createClass(Debouncer, [{
    key: "debounce",
    value: function debounce(func) {
      var _this = this;
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        clearTimeout(_this.timeoutId);
        _this.timeoutId = setTimeout(function () {
          func.apply(context, args);
        }, _this.delay);
      };
    }
  }]);
}();
/** Handles fetching articles from the API **/
var ArticleFetcher = /*#__PURE__*/function () {
  function ArticleFetcher(blogHandle) {
    _classCallCheck(this, ArticleFetcher);
    this.blogHandle = blogHandle;
  }
  return _createClass(ArticleFetcher, [{
    key: "fetchArticles",
    value: function () {
      var _fetchArticles = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(searchTerm) {
        var _response$data$articl, result, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch('/apps/article-search', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  first: 99,
                  searchString: searchTerm,
                  sortKey: 'UPDATED_AT',
                  blogHandle: this.blogHandle
                })
              });
            case 3:
              result = _context.sent;
              _context.next = 6;
              return result.json();
            case 6:
              response = _context.sent;
              return _context.abrupt("return", response && response.data && response.data.articles && ((_response$data$articl = response.data.articles) === null || _response$data$articl === void 0 ? void 0 : _response$data$articl.length) > 0 ? response.data.articles : []);
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              console.error("Error fetching articles: ", _context.t0);
              return _context.abrupt("return", []);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 10]]);
      }));
      function fetchArticles(_x) {
        return _fetchArticles.apply(this, arguments);
      }
      return fetchArticles;
    }()
  }]);
}();
/** Handles updating and rendering article content **/
var ArticleRenderer = /*#__PURE__*/function () {
  function ArticleRenderer(articlesWrapper, articleTemplate) {
    _classCallCheck(this, ArticleRenderer);
    this.articlesWrapper = articlesWrapper;
    this.articleTemplate = articleTemplate;
  }
  return _createClass(ArticleRenderer, [{
    key: "clearArticlesWrapper",
    value: function clearArticlesWrapper() {
      if (this.articlesWrapper) {
        this.articlesWrapper.innerHTML = '';
      }
    }
  }, {
    key: "createArticleElement",
    value: function createArticleElement(article) {
      if (!this.articleTemplate) return null;
      var articleElement = this.articleTemplate.cloneNode(true);
      this.updateArticleElement(articleElement, article);
      return articleElement;
    }
  }, {
    key: "updateArticleElement",
    value: function updateArticleElement(articleElement, article) {
      var _this2 = this;
      var updateMethods = [function () {
        return _this2.updateArticleLinks(articleElement, article);
      }, function () {
        return _this2.updateHiddenElements(articleElement, article);
      }, function () {
        return _this2.updateArticleImage(articleElement, article);
      }, function () {
        return _this2.updateArticleTitle(articleElement, article);
      }, function () {
        return _this2.updateArticleTags(articleElement, article);
      }];
      updateMethods.forEach(function (method) {
        return method();
      });
    }
  }, {
    key: "updateArticleLinks",
    value: function updateArticleLinks(articleElement, article) {
      var articleLinks = articleElement.querySelectorAll('.main-blog__article-link');
      var marketRoute = window.Shopify.routes.root;
      articleLinks.forEach(function (link) {
        var linkPath = article.link.startsWith('/') ? article.link : "/".concat(article.link);
        link.href = "".concat(marketRoute, "blogs").concat(linkPath);
      });
    }
  }, {
    key: "updateHiddenElements",
    value: function updateHiddenElements(articleElement, article) {
      var hiddenElements = articleElement.querySelectorAll('.hidden');
      hiddenElements.forEach(function (element) {
        element.textContent = article.title;
      });
    }
  }, {
    key: "updateArticleImage",
    value: function updateArticleImage(articleElement, article) {
      var articleCardImageWrapper = articleElement.querySelector('.article-card__image-wrapper');
      if (!articleCardImageWrapper) return;
      var articleImage = articleCardImageWrapper.querySelector('img');
      if (articleImage && article.image) {
        var imageProperties = [{
          attr: 'src',
          value: article.image.url
        }, {
          attr: 'alt',
          value: article.image.altText || ''
        }, {
          attr: 'height',
          value: article.image.height
        }, {
          attr: 'width',
          value: article.image.width
        }];
        imageProperties.forEach(function (_ref) {
          var attr = _ref.attr,
            value = _ref.value;
          articleImage.setAttribute(attr, value);
        });
        if (articleImage.hasAttribute('srcset')) {
          articleImage.removeAttribute('srcset');
        }
      }
    }
  }, {
    key: "updateArticleTitle",
    value: function updateArticleTitle(articleElement, article) {
      var articleTitleElement = articleElement.querySelector('.card__heading');
      if (!articleTitleElement) return;
      var articleTitleLink = articleTitleElement.querySelector('a');
      if (articleTitleLink) {
        articleTitleLink.textContent = article.title;
        var linkPath = article.link.startsWith('/') ? article.link : "/".concat(article.link);
        articleTitleLink.href = "/blogs".concat(linkPath);
      }
    }
  }, {
    key: "updateArticleTags",
    value: function updateArticleTags(articleElement, article) {
      var cardTagsList = articleElement.querySelector('.card__tags-list');
      if (!cardTagsList) return;
      var tags = article === null || article === void 0 ? void 0 : article.tags;
      if (!tags || tags.length === 0) {
        cardTagsList.innerHTML = '';
        return;
      }
      cardTagsList.innerHTML = '';
      var tagsToShow = tags.slice(0, 2);
      tagsToShow.forEach(function (tag, index) {
        var li = document.createElement('li');
        li.className = 'card__tags-item';
        li.textContent = tag.replace('-', ' ');
        cardTagsList.appendChild(li);
        if (index < tagsToShow.length - 1) {
          var separator = document.createTextNode('•');
          cardTagsList.appendChild(separator);
        }
      });
    }
  }, {
    key: "renderArticles",
    value: function renderArticles(articles, startIndex, endIndex) {
      var _this3 = this;
      var articlesToShow = articles.slice(startIndex, endIndex);
      articlesToShow.forEach(function (article) {
        var articleElement = _this3.createArticleElement(article);
        if (articleElement && _this3.articlesWrapper) {
          _this3.articlesWrapper.appendChild(articleElement);
        }
      });
    }
  }]);
}();
/** Handles pagination and show more functionality **/
var PaginationManager = /*#__PURE__*/function () {
  function PaginationManager(showMoreElement) {
    var articlesPerPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
    _classCallCheck(this, PaginationManager);
    this.showMoreElement = showMoreElement;
    this.showMoreBtn = showMoreElement === null || showMoreElement === void 0 ? void 0 : showMoreElement.querySelector('.article-search__search__show-more--btn');
    this.articlesPerPage = articlesPerPage;
    this.currentPage = 1;
    this.displayedArticlesCount = 0;
  }
  return _createClass(PaginationManager, [{
    key: "reset",
    value: function reset() {
      this.currentPage = 1;
      this.displayedArticlesCount = 0;
    }
  }, {
    key: "shouldShowMore",
    value: function shouldShowMore(totalArticles) {
      return totalArticles > this.articlesPerPage && this.displayedArticlesCount < totalArticles;
    }
  }, {
    key: "toggleShowMore",
    value: function toggleShowMore() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.showMoreElement) {
        this.showMoreElement.classList.toggle('hidden', !show);
      }
    }
  }, {
    key: "getNextPageRange",
    value: function getNextPageRange() {
      var startIndex = this.displayedArticlesCount;
      var endIndex = Math.min(startIndex + this.articlesPerPage, Number.MAX_SAFE_INTEGER);
      return {
        startIndex: startIndex,
        endIndex: endIndex
      };
    }
  }, {
    key: "updateDisplayedCount",
    value: function updateDisplayedCount(newCount) {
      this.displayedArticlesCount = newCount;
    }
  }, {
    key: "nextPage",
    value: function nextPage() {
      this.currentPage++;
    }
  }]);
}();
var ArticleSearch = /*#__PURE__*/function (_HTMLElement) {
  function ArticleSearch() {
    var _this4;
    _classCallCheck(this, ArticleSearch);
    _this4 = _callSuper(this, ArticleSearch);

    /** Elements **/
    _this4.input = null;
    _this4.submitButton = null;
    _this4.noResultsElement = null;
    _this4.articlesWrapper = null;
    _this4.paginationWrapper = null;
    _this4.totalArticlesElement = null;
    _this4.paginationElement = null;
    _this4.showMore = null;
    _this4.blogFilterItems = null;

    /** Variables **/
    _this4.activeButtonBg = null;
    _this4.submitButtonOriginalIcon = null;
    _this4.totalArticlesOriginalText = null;
    _this4.blogHandle = null;
    _this4.totalBlogsToShow = null;

    /** Articles Data **/
    _this4.articles = [];
    _this4.articleTemplate = null;

    /** Helper Classes **/
    _this4.debouncer = new Debouncer(300);
    _this4.articleFetcher = null;
    _this4.articleRenderer = null;
    _this4.paginationManager = null;
    return _this4;
  }
  _inherits(ArticleSearch, _HTMLElement);
  return _createClass(ArticleSearch, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initializeElements();
      this.initializeHelperClasses();
      this.initializeFromUrlParams();
      this.attachEventListeners();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeEventListeners();
    }
  }, {
    key: "initializeElements",
    value: function initializeElements() {
      this.input = this.querySelector('.article-search__search__input--field');
      this.submitButton = this.querySelector('.article-search__search__submit');
      this.noResultsElement = document.querySelector('.article-search__search__no-results');
      this.articlesWrapper = document.querySelector('.blog-articles');
      this.paginationWrapper = document.querySelector('.pagination-wrapper');
      this.totalArticlesElement = document.querySelector('.article-search__search--total-articles');
      this.paginationElement = document.querySelector('.pagination-wrapper');
      this.showMore = document.querySelector('.article-search__search__show-more');
      this.blogFilterItems = document.querySelectorAll('.blog-filters__item');
      this.activeButtonBg = this.submitButton.dataset.activeButtonBg;
      this.blogHandle = window.location.href.split('/').pop().split('?')[0];
      this.submitButtonOriginalIcon = this.submitButton.innerHTML;
      this.totalArticlesOriginalText = this.totalArticlesElement.textContent;
      this.totalBlogsToShow = parseInt(this.articlesWrapper.dataset.totalBlogs);

      /** Store the first article element as a template for cloning **/
      var firstArticle = this.articlesWrapper.querySelector('.blog-articles__article');
      if (firstArticle) {
        this.articleTemplate = firstArticle.cloneNode(true);
      }

      /** Ensure The Inital State Of The Button Has A Transparent Background **/
      this.removeButtonBackground();
    }
  }, {
    key: "initializeHelperClasses",
    value: function initializeHelperClasses() {
      this.articleFetcher = new ArticleFetcher(this.blogHandle);
      this.articleRenderer = new ArticleRenderer(this.articlesWrapper, this.articleTemplate);
      this.paginationManager = new PaginationManager(this.showMore);
    }
  }, {
    key: "attachEventListeners",
    value: function attachEventListeners() {
      var _this5 = this;
      var debouncedUIUpdate = this.debouncer.debounce(this.handleInputInteraction, this);
      var eventMappings = [{
        element: this.submitButton,
        event: 'click',
        handler: this.handleSearch
      }, {
        element: this.input,
        event: 'keypress',
        handler: this.handleKeyPress
      }, {
        element: this.input,
        event: 'input',
        handler: function handler() {
          debouncedUIUpdate();
        }
      }, {
        element: this.input,
        event: 'focus',
        handler: this.handleInputFocus
      }, {
        element: this.input,
        event: 'blur',
        handler: this.handleInputBlur
      }, {
        element: this.paginationManager.showMoreBtn,
        event: 'click',
        handler: this.handleShowMore
      }];
      eventMappings.forEach(function (_ref2) {
        var element = _ref2.element,
          event = _ref2.event,
          handler = _ref2.handler;
        if (element) {
          element.addEventListener(event, handler.bind(_this5));
        }
      });
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      var _this6 = this;
      var eventMappings = [{
        element: this.submitButton,
        event: 'click',
        handler: this.handleSearch
      }, {
        element: this.input,
        event: 'keypress',
        handler: this.handleKeyPress
      }, {
        element: this.input,
        event: 'input',
        handler: this.handleInputChange
      }, {
        element: this.input,
        event: 'focus',
        handler: this.handleInputFocus
      }, {
        element: this.input,
        event: 'blur',
        handler: this.handleInputBlur
      }, {
        element: this.paginationManager.showMoreBtn,
        event: 'click',
        handler: this.handleShowMore
      }];
      eventMappings.forEach(function (_ref3) {
        var element = _ref3.element,
          event = _ref3.event,
          handler = _ref3.handler;
        if (element) {
          element.removeEventListener(event, handler.bind(_this6));
        }
      });
    }
  }, {
    key: "handleInputInteraction",
    value: function handleInputInteraction() {
      var shouldAddBackground = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var searchTerm = this.input ? this.input.value.trim() : '';
      if (shouldAddBackground && searchTerm) {
        this.addButtonBackground();
      } else if (!shouldAddBackground && !searchTerm) {
        this.removeButtonBackground();
      } else if (searchTerm) {
        this.addButtonBackground();
      } else {
        this.removeButtonBackground();
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange() {
      this.handleInputInteraction();
    }
  }, {
    key: "handleInputFocus",
    value: function handleInputFocus() {
      this.handleInputInteraction(true);
    }
  }, {
    key: "handleInputBlur",
    value: function handleInputBlur() {
      this.handleInputInteraction();
    }
  }, {
    key: "toggleButtonBackground",
    value: function toggleButtonBackground() {
      var add = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!this.submitButton) return;
      if (add && this.activeButtonBg) {
        this.submitButton.style.backgroundColor = this.activeButtonBg;
      } else {
        this.submitButton.style.backgroundColor = 'transparent';
      }
    }
  }, {
    key: "addButtonBackground",
    value: function addButtonBackground() {
      this.toggleButtonBackground(true);
    }
  }, {
    key: "removeButtonBackground",
    value: function removeButtonBackground() {
      this.toggleButtonBackground(false);
    }
  }, {
    key: "initializeFromUrlParams",
    value: function () {
      var _initializeFromUrlParams = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var urlParams, searchParam;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              urlParams = new URLSearchParams(window.location.search);
              searchParam = urlParams.get('s');
              if (!(searchParam && this.input)) {
                _context2.next = 6;
                break;
              }
              this.input.value = searchParam;
              _context2.next = 6;
              return this.performSearch(searchParam);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function initializeFromUrlParams() {
        return _initializeFromUrlParams.apply(this, arguments);
      }
      return initializeFromUrlParams;
    }()
  }, {
    key: "handleSearch",
    value: function () {
      var _handleSearch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event) {
        var searchTerm;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              event.preventDefault();
              searchTerm = this.input ? this.input.value.trim() : '';
              if (!searchTerm) {
                _context3.next = 6;
                break;
              }
              this.updateUrlWithSearchParam(searchTerm);
              _context3.next = 6;
              return this.performSearch(searchTerm);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleSearch(_x2) {
        return _handleSearch.apply(this, arguments);
      }
      return handleSearch;
    }()
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      if (event.key === 'Enter') {
        this.handleSearch(event);
      }
    }
  }, {
    key: "updateUrlWithSearchParam",
    value: function updateUrlWithSearchParam(searchTerm) {
      var url = new URL(window.location);
      url.searchParams.set('s', searchTerm);
      window.history.pushState({}, '', url);
    }
  }, {
    key: "performSearch",
    value: function () {
      var _performSearch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(searchTerm) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              this.toggleButtonLoading(true);
              this.paginationManager.reset();
              _context4.next = 5;
              return this.articleFetcher.fetchArticles(searchTerm);
            case 5:
              this.articles = _context4.sent;
              if (!this.articles || this.articles.length === 0) {
                this.toggleResultsDisplay(false);
                this.paginationManager.toggleShowMore(false);
                this.removeActiveClassFromBlogFilterItems();
              } else {
                this.toggleResultsDisplay(true, this.articles.length);
                this.showArticles(this.articles);
                this.removeActiveClassFromBlogFilterItems();
              }
              _context4.next = 14;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              console.error("Error performing search: ", _context4.t0);
              this.toggleResultsDisplay(false);
              this.removeActiveClassFromBlogFilterItems();
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 9]]);
      }));
      function performSearch(_x3) {
        return _performSearch.apply(this, arguments);
      }
      return performSearch;
    }() /** Remove The Active Class From All Of The Blog Filter Items **/
  }, {
    key: "removeActiveClassFromBlogFilterItems",
    value: function removeActiveClassFromBlogFilterItems() {
      this.blogFilterItems.forEach(function (item) {
        item.classList.remove('blog-filters__item--active');
      });
    }
  }, {
    key: "toggleResultsDisplay",
    value: function toggleResultsDisplay(hasResults) {
      var articlesLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var elementsToToggle = [{
        element: this.noResultsElement,
        show: !hasResults
      }, {
        element: this.articlesWrapper,
        show: hasResults
      }, {
        element: this.paginationWrapper,
        show: hasResults
      }, {
        element: this.totalArticlesElement,
        show: hasResults
      }];
      elementsToToggle.forEach(function (_ref4) {
        var element = _ref4.element,
          show = _ref4.show;
        if (element) {
          element.classList.toggle('hidden', !show);
        }
      });
      if (hasResults && this.totalArticlesElement) {
        this.totalArticlesElement.textContent = "".concat(articlesLength, " ").concat(this.totalArticlesOriginalText);
      }
      this.toggleButtonLoading(false);
      this.removeButtonBackground();
    }
  }, {
    key: "toggleButtonLoading",
    value: function toggleButtonLoading(isLoading) {
      if (!this.submitButton) return;
      if (isLoading) {
        this.submitButton.classList.add('article-search__search__submit--loading');
        this.submitButton.innerHTML = "";
      } else {
        this.submitButton.classList.remove('article-search__search__submit--loading');
        this.submitButton.innerHTML = this.submitButtonOriginalIcon;
      }
    }
  }, {
    key: "showArticles",
    value: function showArticles(articles) {
      if (!articles || articles.length === 0) return;

      /** For new search, clear existing articles **/
      if (this.paginationManager.currentPage === 1) {
        this.articleRenderer.clearArticlesWrapper();
      }

      /** Calculate articles to show for current page **/
      var _this$paginationManag = this.paginationManager.getNextPageRange(),
        startIndex = _this$paginationManag.startIndex,
        endIndex = _this$paginationManag.endIndex;
      var actualEndIndex = Math.min(endIndex, articles.length);

      /** Render articles **/
      this.articleRenderer.renderArticles(articles, startIndex, actualEndIndex);
      this.paginationManager.updateDisplayedCount(actualEndIndex);

      /** Show/hide "Show More" button **/
      this.paginationManager.toggleShowMore(this.paginationManager.shouldShowMore(articles.length));
      this.toggleButtonLoading(false);
      this.removeButtonBackground();
      this.hidePagination();
    }
  }, {
    key: "hidePagination",
    value: function hidePagination() {
      if (this.paginationElement) {
        this.paginationElement.classList.add('hidden');
      }
    }
  }, {
    key: "handleShowMore",
    value: function handleShowMore() {
      this.paginationManager.nextPage();
      this.showArticles(this.articles);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('article-search', ArticleSearch);
/******/ })()
;